import { withMotion } from '@hoc/withMotion';
import SvgChevron from '@img/icons/chevron-right.svg';
import { FocusRing, useFocusManager } from '@react-aria/focus';
import Checkbox from '@stories/Components/Inputs/Checkbox/Checkbox';
import * as React from 'react';
import S from './DropdownFilter.styles';
const DropdownFilter = (props) => {
    const [isActive, setIsActive] = React.useState(false);
    const fm = useFocusManager();
    const refFilterItem = React.useRef(null);
    const [openGroup, setOpenGroup] = React.useState('');
    const handleRefFilterItemBlur = React.useCallback((e) => {
        if (refFilterItem.current && !refFilterItem.current.contains(e.target)) {
            setIsActive(false);
            document.removeEventListener('click', handleRefFilterItemBlur);
        }
    }, []);
    React.useEffect(() => {
        if (isActive && refFilterItem.current) {
            window.addEventListener('click', handleRefFilterItemBlur);
        }
    }, [isActive, handleRefFilterItemBlur]);
    return (React.createElement(S.FilterItem, { initial: isActive ? 'opened' : 'closed', animate: isActive ? 'opened' : 'closed', onKeyDown: (event) => {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusNext();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusPrevious();
                    break;
                case 'Home':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusFirst();
                    break;
                case 'End':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusLast();
                    break;
                default:
                    break;
            }
        }, ref: refFilterItem },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.FilterLabel, { "aria-expanded": isActive, onClick: (event) => {
                    event.preventDefault();
                    setIsActive(!isActive);
                } },
                props.label,
                React.createElement(S.FilterItemIcon, { "aria-hidden": "true", variants: {
                        closed: {
                            rotate: 90,
                        },
                        opened: {
                            rotate: 270,
                        },
                    } },
                    React.createElement(SvgChevron, null)))),
        React.createElement(S.FilterItemBody, { role: "region", tabIndex: -1, variants: {
                closed: {
                    height: 0,
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                },
                opened: {
                    visibility: 'visible',
                    height: 'auto',
                },
            } },
            React.createElement(S.FilterItemBodyInner, null,
                React.createElement(S.CheckboxList, { "data-size": "large" }, props.options.map((option) => (React.createElement(React.Fragment, { key: `option-${props.name}-${option.label}` },
                    props.options.length > 1 && (React.createElement(S.FilterGroupButton, { "data-open": openGroup === option.label, onClick: () => {
                            if (openGroup === option.label) {
                                setOpenGroup('');
                            }
                            else {
                                setOpenGroup(option.label);
                            }
                        } },
                        option.label,
                        React.createElement(S.FilterGroupButtonIcon, null))),
                    React.createElement(S.FilterItemBody, { variants: {
                            closed: {
                                height: 0,
                                visibility: 'hidden',
                            },
                            opened: {
                                visibility: 'visible',
                                height: 'auto',
                            },
                        }, initial: !isActive || props.options.length > 1 ? 'closed' : 'opened', animate: isActive && (props.options.length === 1 || openGroup === option.label)
                            ? 'opened'
                            : 'closed' }, option.options.map((o) => (React.createElement(Checkbox, { key: `option-${props.name}-${o.value}`, id: `${props.name}-${o.value}`, name: `${props.name}-${o.value}`, value: o.value, onChange: (event) => props.onChange(event.target.value), checked: props.value.includes(o.value), labelText: o.text, "data-size": "large" }))))))))))));
};
export default withMotion(DropdownFilter);
